export const hoverableElements = {
  QUOTE: "quote",
  PROJECT: "project",
  BOARD: "board",
};

export const temp = {};
